export interface Response {
	code: number;
	message: string;
	data: any;
}
